import { render } from "./PageBanner.vue?vue&type=template&id=8352b92a&scoped=true"
import script from "./PageBanner.vue?vue&type=script&lang=js"
export * from "./PageBanner.vue?vue&type=script&lang=js"

import "./PageBanner.vue?vue&type=style&index=0&id=8352b92a&scoped=true&lang=css"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8352b92a"]])

export default __exports__